var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{style:(_vm.getSize(_vm.name)),attrs:{"viewBox":_vm.getViewBox(_vm.name),"data-icon-name":_vm.name},domProps:{"innerHTML":_vm._s(_vm.getSVG(_vm.name))}})
}
var staticRenderFns = []

export { render, staticRenderFns }